import { defineComponent as _defineComponent } from 'vue';
import { faUndo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton, BModal } from "bootstrap-vue";
import { ref } from "vue";
import { useActivityStore } from "@/stores/activityStore";
import ActivitySettings from "@/components/ActivityBar/ActivitySettings.vue";
import DelayedInput from "@/components/Common/DelayedInput.vue";
import ActivityPanel from "@/components/Panels/ActivityPanel.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'SettingsPanel',
    props: {
        activityBarId: null,
        heading: null,
        searchPlaceholder: null
    },
    emits: ["activityClicked"],
    setup(__props, { emit }) {
        const props = __props;
        const activityStore = useActivityStore(props.activityBarId);
        const confirmRestore = ref(false);
        const query = ref("");
        function onQuery(newQuery) {
            query.value = newQuery;
        }
        return { __sfc: true, props, emit, activityStore, confirmRestore, query, onQuery, faUndo, FontAwesomeIcon, BButton, BModal, ActivitySettings, DelayedInput, ActivityPanel };
    }
});
